module.exports = __webpack_public_path__ + "static/media/timpani.6bd9bbc6.wav";